export default __webpack_public_path__ + "static/media/intro_background.04504fa6.jpg";